export function toRecord<T extends object>(array: T[], mapper: (item: T) => string) : Record<string, T>
{
    return array.reduce((p, c) => ({ ...p, [mapper(c)]: c }), { });
}